var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxBallot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 464C0 490.51 21.49 512 48 512H528C554.51 512 576 490.51 576 464V352H0V464ZM448 24C448 10.744 437.254 0 424 0H152C138.746 0 128 10.744 128 24V224H448V24ZM544 160H480V224C480 241.672 465.674 256 448 256H128C110.326 256 96 241.672 96 224V160H32C14.326 160 0 174.326 0 192V319.125L0.875 320H575.125L576 319.125V192C576 174.326 561.674 160 544 160Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxBallot);
export default __webpack_public_path__ + "static/media/box-ballot.b032b12cfe0638f2f9abd9b9bf711f7e.svg";
export { ForwardRef as ReactComponent };